import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Accordion from 'srcReact/components/common2/Accordion'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import Email from 'srcReact/LoginPage/components/Email'
import Password from 'srcReact/LoginPage/components/Password'
import { useDispatch, useSelector } from 'react-redux'
import OrgSelection from '../components/OrgSelection'
import queryString from 'query-string'
import { checkNested, isEmpty } from 'srcReact/helpers/validator'
import { decode_utf8, getCookie, isIOS, setCookie } from 'srcReact/helpers/utils'
import WorkplaceInvitation from '../components/WorkplaceInvitation'
import ConfirmPassword from '../components/ConfirmPassword'

function LoginContainer(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [currentStep, setCurrentStep] = useState('email')
  const [triggeredAction, setTriggeredAction] = useState({})
  const [currentState, setCurrentState] = useState({ keepLoggedIn: false, agreeMixrTerms: false })
  const [loginFaq, setLoginFaq] = useState(t('faqs.login', { returnObjects: true }))
  const [passwordFaq, setPasswordFaq] = useState(t('faqs.password', { returnObjects: true }))
  const {
    common: { isNative },
    login: { email, idps, is_registered, organizations, workplace_invitations, loading, user, error, firstname },
    authentication: {
      passwordResetLinkError,
      passwordResetLinkErrorMessage,
      passwordResetLinkSent,
      passwordResetLinkSentLoading
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (!isEmpty(user)) {
      window.location = `${location.protocol}//${location.hostname}`
    }

    const query = queryString.parse(location.search)
    if (query && query.ruaa) {
      setTriggeredAction({
        url: query.ruaa,
        trigger: 'afterLogin'
      })
    } else if (!isIOS() && getCookie('redirectUrlAfterAuth') != null) {
      let redirectUrl = getCookie('redirectUrlAfterAuth')
      setTriggeredAction({
        url: decode_utf8(redirectUrl),
        trigger: 'afterLogin'
      })
    } else if (checkNested('location', 'state', 'from', 'pathname') && !location.state.from.pathname.match(/auth/)) {
      let redirectUrl = `${location.protocol}//${location.hostname}${location.state.from.pathname}`
      setCookie('redirectUrlAfterAuth', redirectUrl, 1)
      setTriggeredAction({
        url: redirectUrl,
        trigger: 'afterLogin'
      })
    }
  }, [])

  return (
    <PageContainer
      pageTitle={t('meta.login.title')}
      pageDescription={t('meta.login.description')}
      pageKeywords={t('meta.login.keywords')}
      withHeader={true}
      withFooter={false}
      isPlainBanner={true}>
      <div className={styles.login}>
        <div className={styles.loginContainer}>
          <div className={styles.loginLeft}>
            <p className={styles.loginText}>{t('login.quote')}</p>
          </div>
          <div className={styles.loginRight}>
            {currentStep === 'email' ? (
              <Email
                isNative={isNative}
                value={email || currentState.email}
                currentState={currentState}
                setCurrentState={setCurrentState}
                setCurrentStep={setCurrentStep}
                idps={idps}
                organizations={organizations}
                workplaceInvitations={workplace_invitations}
                isRegistered={is_registered}
                loading={loading}
              />
            ) : currentStep === 'org-selection' ? (
              <OrgSelection
                isNative={isNative}
                currentState={currentState}
                setCurrentState={setCurrentState}
                setCurrentStep={setCurrentStep}
                organizations={organizations}
                workplaceInvitationCount={workplace_invitations.length}
                isRegistered={is_registered}
                idps={idps}
              />
            ) : currentStep === 'workplace-invitation' ? (
              <WorkplaceInvitation
                currentState={currentState}
                setCurrentState={setCurrentState}
                setCurrentStep={setCurrentStep}
                organizations={organizations}
                workplace_invitations={workplace_invitations}
                isRegistered={is_registered}
                idps={idps}
              />
            ) : currentStep === 'password' ? (
              <Password
                currentState={currentState}
                setCurrentState={setCurrentState}
                setCurrentStep={setCurrentStep}
                passwordResetLinkError={passwordResetLinkError}
                passwordResetLinkErrorMessage={passwordResetLinkErrorMessage}
                passwordResetLinkSent={passwordResetLinkSent}
                passwordResetLinkSentLoading={passwordResetLinkSentLoading}
                triggeredAction={triggeredAction}
                error={error}
                loading={loading}
                firstname={firstname}
              />
            ) : currentStep === 'confirm-password' ? (
              <ConfirmPassword
                currentState={currentState}
                setCurrentState={setCurrentState}
                setCurrentStep={setCurrentStep}
                error={error}
                loading={loading}
                workplaceInvitations={workplace_invitations}
              />
            ) : null}
          </div>
        </div>
        {currentStep === 'email' ? (
          <Accordion data={[...loginFaq, ...passwordFaq]} className={styles.accordion} />
        ) : currentStep === 'password' ? (
          <Accordion data={passwordFaq} className={styles.accordion} />
        ) : null}
      </div>
    </PageContainer>
  )
}

export { LoginContainer }
